import Profile from '../components/Profile/Profile';

const ProfileScreen = () => <Profile />;
export default ProfileScreen;
